module.exports = __webpack_public_path__ + "img/4. Reduced prices-en.eb6a3e2.png";